import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';


const NextPage = ({ pagetype, store }) => {
  const checkoutsteps = store.getState().checkoutsettings.checkoutSettings.checkout_steps;

  /************ SELECTED ************** */
  const [shipordeliver, setShipOrDeliver] = useState(store.getState().selectedorderdata?.shipordeliverdata || '');



  useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      setShipOrDeliver(store.getState().selectedorderdata.shipordeliverdata || '');
   
    });
  
    return () => {
      unsubscribe();
    };
  }, []);



  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    // Hier die Route, zu der navigiert wird
    if (checkoutsteps === 'select2' && pagetype === 'address') {
      navigate('/ips-payment');
    }else if (checkoutsteps === 'select2' && pagetype === 'payment') {
      navigate('/ips-orderreview');
    } else if (checkoutsteps === 'select3' && pagetype === 'address' && shipordeliver === 'delivery') {
      navigate('/ips-shipping');
    }else if (checkoutsteps === 'select3' && pagetype === 'address' && shipordeliver === 'pickup') {
      navigate('/ips-payment');
    }  else if (checkoutsteps === 'select3' && pagetype === 'shipping') {
      navigate('/ips-payment');
    }else if (checkoutsteps === 'select3' && pagetype === 'payment') {
      navigate('/ips-orderreview');
    }
  };

  let content = null;
  if (checkoutsteps === 'select2' && pagetype === 'address') {
    content = (
      <>
        <button className="w-100 btn ips-btn-primary-checkout btn-lg" type="submit">Continue to payment</button>
      </>
    );
  }else if (checkoutsteps === 'select2' && pagetype === 'payment') {
    content = (
      <>
        <button className="w-100 btn ips-btn-primary-checkout btn-lg" type="submit">Continue to summary</button>
      </>
    );
  } else if (checkoutsteps === 'select3' && pagetype === 'address') {
    content = (
      <>
        <button className="w-100 btn ips-btn-primary-checkout btn-lg" type="submit">Continue to shipping</button>
      </>
       );
      }else if (checkoutsteps === 'select3' && pagetype === 'shipping') {
    content = (
      <>
          <div className="row pt-2 g-3">
        <div className="col">
      
          {pagetype === 'shipping' && <Link to="/informations" className="nav-item nav-link backarrow">&larr; Zurück</Link>}
        </div>
        <div className="col text-end">
          <button className="btn ips-btn-primary-checkout btn-lg" type="submit" name="woocommerce_checkout_place_order" id="place_order" >Continue to payment</button>
        </div>
        </div>
      </>
    );
  }else if (checkoutsteps === 'select3' && pagetype === 'payment') {
    content = (
      <>
          <div className="row pt-2 g-3">
        <div className="col">
        {pagetype === 'payment' && <Link to="/ips-shipping" className="nav-item nav-link backarrow">&larr; Zurück</Link>}
       
        </div>
        <div className="col text-end">
          <button className="btn ips-btn-primary-checkout btn-lg" name="woocommerce_checkout_summary" id="ips_place_summary" >Continue to summary</button>
        </div>
        </div>
      </>
    );
  }

  return (
    <form className="needs-validation" noValidate onSubmit={handleSubmit}>
      <div id="ips-address-details" className="ips-module">
        <div className="row g-3">
          {content}
          <hr className="my-4" />
        </div>
      </div>
    </form>
  );
};

export default NextPage;